import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr1012',
    ecrans: ['00-2']
});
